<template>
    <footer id="footer" class="m-0 background-color-primary">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <h4 class="mb-3">{{ $t('base.footer.columns.first.title') }}</h4>
                    <p class="grey-text mb-0">
                        La Strada da Pizzögna 3<br>
                        CH - 6574 Vira Gambarogno<br>
                        {{ $t('common.keywords.CH') }}<br>
                        {{ $t('common.generalities.phoneNumber') }}: +41 (0)91 795 35 90<br>
                        Email: <a class="text-color-secondary" href="mailto:info@casafile.ch" style="color: white !important">info@casafile.ch</a>
                    </p>
                </div>
                <div class="col-lg-4">
                    <h4 class="mb-3">{{ $t('base.footer.columns.second.title') }}</h4>
                    <nav class="nav-footer">
                        <ul class="custom-list-style-1 mb-0">
                            <li>
                                <a :href="$t('base.footer.columns.second.children.insert.url')" class="grey-text text-decoration-none">
                                    {{ $t('base.footer.columns.second.children.insert.title') }}
                                </a>
                            </li>
                            <li>
                                <a href="https://www.admin.ferienwohnungen-tessin.ch" class="grey-text text-decoration-none">
                                    {{ $t('base.footer.columns.second.children.login.title') }}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="col-lg-4">
                    <h4 class="mb-3">{{ $t('base.footer.columns.third.title') }}</h4>
                    <nav class="nav-footer">
                        <ul class="custom-list-style-1 mb-0">
                            <li>
                                <a href="https://immobilien-tessin.ch" class="grey-text text-decoration-none">
                                    {{ $t('base.footer.columns.third.children.objects.title') }}
                                </a>
                            </li>
                            <li>
                                <a href="https://www.casafile.ch/immobilien_verkauf.htm" class="grey-text text-decoration-none"> <!-- TODO: CHANGE ME <?php echo $SELL_URL; ?> -->
                                    {{ $t('base.footer.columns.third.children.sell.title') }}
                                </a>
                            </li>
                            <li>
                                <a href="https://www.casafile.ch/schaetzungen.htm" class="grey-text text-decoration-none"> <!-- TODO: CHANGE ME <?php echo $SCHAETZUNGEN_URL; ?> -->
                                    {{ $t('base.footer.columns.third.children.evaluate.title') }}
                                </a>
                            <li>
                                <a href="https://www.casafile.ch/team.htm" class="grey-text text-decoration-none"> <!-- TODO: CHANGE ME <?php echo $ABOUT_US_URL; ?> -->
                                    {{ $t('base.footer.columns.third.children.about.title') }}
                                </a>
                            </li>
                            <li>
                                <a href="https://www.casafile.ch/kontakt.htm" class="grey-text text-decoration-none"> <!-- TODO: CHANGE ME <?php echo $CONTACT_US_URL ?> -->
                                    {{ $t('base.footer.columns.third.children.contact.title') }}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div class="row">
                <div class="col-12 offset-md-3 col-md-6 offset-xl-4 col-xl-4 d-flex justify-content-between " style="margin-bottom: 0">
                    <SocialIcon 
                        v-for="social in socials" 
                        :icon="social.icon" 
                        :link="social.url" 
                        :key="social.url"
                    />
                </div>
            </div>
        </div>
        <div class="footer-copyright background-color-primary pb-0" style="margin-top: 0px !important;">
            <div class="container">
                <div class="row pt-3 pb-3">
                    <div class="col-lg-12 left m-0 grey-text">
                        <p class="grey-text">{{ $t('base.footer.copyright.title', { year: currentYear }) }}</p>
                        <p class="grey-text" v-html="$t('base.footer.copyright.content')"></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import SocialIcon from "@/components/common/SocialIcon"
export default {
    name: 'Footer',
    components: {
        SocialIcon
    },
    computed: {
        currentYear: function() {
            return new Date().getFullYear();
        }
    },
    data() {
        return {
            socials: [
                {
                    name: "Facebook",
                    icon: "fab fa-facebook",
                    url: "https://facebook.com/casafile"
                },
                {
                    name: "Instagram",
                    icon: "fab fa-instagram",
                    url: "https://instagram.com/casafile"
                },
                {
                    name: "Pinterest",
                    icon: "fab fa-pinterest",
                    url: "https://pinterest.com/casafile"
                },
                {
                    name: "Twitter",
                    icon: "fab fa-twitter",
                    url: "https://twitter.com/casafile"
                },
                {
                    name: "Linkedin",
                    icon: "fab fa-linkedin",
                    url: "https://linkedin.com/company/casafile"
                },
            ]
        }
    }
}
</script>

<style scoped lang="scss">
    #footer {
        // Header is 10000, we keep this just a touch under
        z-index: 9999;
    }
</style>